export default __webpack_public_path__ + "static/media/bs5.2.1a050937.png";